import { DIRECT_EEG_UPLOAD_THRESHOLD_BYTES } from "./eegUploadConstants";
import type { StagedSessionFileUpload } from "./resumableEegUploadClient";

/** Never send more than this as a single portal→API multipart POST. */
export const SESSION_MULTIPART_MAX_BYTES = 32 * 1024 * 1024;

export function shouldStageEegSessionUpload(input: {
  fileCount: number;
  companionCount: number;
  payloadBytes: number;
}): boolean {
  return (
    input.companionCount > 0 ||
    input.fileCount > 1 ||
    input.payloadBytes >= SESSION_MULTIPART_MAX_BYTES ||
    input.payloadBytes >= DIRECT_EEG_UPLOAD_THRESHOLD_BYTES
  );
}

export function buildStagedSessionUploadFormData(input: {
  stagedUploads: StagedSessionFileUpload[];
  studyId: string;
  sessionId: string;
  owningTeamId?: string | null;
  forceIncompatible?: boolean;
  patientMismatchOverride?: boolean;
}): FormData {
  const formData = new FormData();
  formData.append("staged_uploads", JSON.stringify(input.stagedUploads));
  formData.append("study_id", input.studyId);
  formData.append("session_id", input.sessionId);
  if (input.owningTeamId) {
    formData.append("owning_team_id", input.owningTeamId);
  }
  if (input.forceIncompatible) {
    formData.append("force_incompatible", "true");
  }
  if (input.patientMismatchOverride) {
    formData.append("patient_mismatch_override", "true");
  }
  return formData;
}
